import { render, staticRenderFns } from "./InvoiceSearch.vue?vue&type=template&id=4308bb3c&lang=pug"
import script from "./InvoiceSearch.vue?vue&type=script&lang=ts"
export * from "./InvoiceSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports